
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import Paging from '@/shared/components/Paging.vue';
import { Order } from '@/models/order';
import { SummaryOrderModel } from '@/models/summary-order';

import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';

import orderService from '@/services/order-service';
import cartServices from '@/services/cart-services';
import authService from '@/services/auth-services';
import commonService from '@/services/common-services';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';

import ListOrder from './components/ListOrder.vue';
import FilterBox from './components/FilterBox.vue';
import SummaryOrder from './components/SummaryOrder.vue';

const FileSaver = require('file-saver');

@Component({
    components: {
        ListOrder,
        FilterBox,
        Paging,
        Loading,
        ConfirmModal,
        SummaryOrder
    }
})
export default class MainOrder extends Vue {
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };
    private isLoading = false;
    private listOrder: Order[] = [];
    private summaryOrder: SummaryOrderModel = new SummaryOrderModel();
    // private filters: Array<{ column: string, value: any, condition: string }> = [];
    // private quickFilters: Array<{ column: string, value: any, condition: string }> = [];

    private selectedStatus = { value: -1, name: 'Tất cả', color: '#fff' };
    private searchText = '';
    private isCheckAll = false;

    private customerInfo: any = {};

    private showNextConfirm = true;
    private isConfirm = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';

    private actions = {
        cancel: 'cancel',
        deposit: 'deposit',
        new: 'new'
    };
    private actionSelected: any = this.actions.cancel;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDiscount() {
        return this.customerLevels.find((cl) => cl.ID === this.customerInfo.LevelID);
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get totalChoose() {
        return this.listOrder.filter(x => x.isChecked === true).length;
    }

    get amountNeedDeposit() {
        return this.listOrder.reduce((amount: number, order: Order) => {
            return amount + (order.isChecked === true && order.status === 0 ? order.minDeposit || 0 : 0)
        }, 0);
    }

    get isShowSummary() {
        return [-1, 0, 7].filter(x => x === this.selectedStatus.value).length > 0;
    }

    private async created() {
        await this.getCustomersInfo();
        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
        await this.getListData();
    }

    private getStatus(value: any) {
        return DATA.orderStatus.find(x => x.value === value) || { value: 0, name: 'N/A', color: '#49494a' };
    }

    private async exportData() {
        this.isLoading = true;
        const filters: any = this.onBuildFilter();
        const res = await orderService.exportData(filters.filters, filters.quickFilters);
        this.isLoading = false;
        const blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'});
        FileSaver.saveAs(blob, `DonHang_${new Date().getTime()}.xlsx`);
    }

    private async getListData() {
        this.isLoading = true;
        // this.listOrder = [];
        this.pageSettings.total = 0;
        this.summaryOrder = new SummaryOrderModel();
        const filters: any = this.onBuildFilter();
        const result = await orderService.orderList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        if (result && result.data && result.data.status === 200) {
            const tmpListOrder: Order[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                totalAmountStoreVN: result.data.summary.TotalAmountStoreVN || 0,
                totalLeftStoreVN: result.data.summary.TotalLeftStoreVN || 0,
                totalAmountNotDeposit: result.data.summary.TotalAmountNotDeposit || 0,
                totalNeedDeposit: result.data.summary.TotalNeedDeposit || 0,
                totalAmountStoreCN: result.data.summary.TotalAmountStoreCN || 0,
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus0: result.data.summary.TotalStatus0 || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus2: result.data.summary.TotalStatus2 || 0,
                TotalStatus3: result.data.summary.TotalStatus3 || 0,
                TotalStatus4: result.data.summary.TotalStatus4 || 0,
                TotalStatus5: result.data.summary.TotalStatus5 || 0,
                TotalStatus7: result.data.summary.TotalStatus7 || 0,
                TotalStatus9: result.data.summary.TotalStatus9 || 0,
                TotalStatus10: result.data.summary.TotalStatus10 || 0,
                TotalStatus11: result.data.summary.TotalStatus11 || 0,
                TotalStatus12: result.data.summary.TotalStatus12 || 0,
                TotalStatus13: result.data.summary.TotalStatus13 || 0,
                TotalStatus16: result.data.summary.TotalStatus16 || 0,
            };

            for (const item of result.data.data) {
                const order = new Order();
                order.id = item.ID;
                order.shopName = item.ShopName;
                order.site = item.Site;
                order.status = item.Status;
                order.statusDetail = this.getStatus(item.Status);
                order.uId = item.UID;
                order.exchangeRate = item.ExchangeRate;
                order.totalAmountVND = item.TotalAmountVND;
                order.deposit = item.Deposit;
                order.minDeposit = item.MinDeposit;
                order.imageOrigin = item.image_origin;
                order.linkNote = item.comments;
                order.isChecked = false;
                order.createdDate = item.CreatedDate;
                order.depositDate = item.DepositDate;
                order.boughtDate = item.BoughtDate;
                order.shopDeliverDate = item.ShopDeliverDate;
                order.storeCNImDate = item.StoreCNImDate;
                order.storeCNExDate = item.StoreCNExDate;
                order.storeVNImDate = item.StoreVNImDate;
                order.storeVNExDate = item.StoreVNExDate;
                order.completedDate = item.CompletedDate;

                tmpListOrder.push(order);
            }
            this.listOrder = tmpListOrder;
        } else {
            this.listOrder = [];
        }

        this.isLoading = false;
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

     private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.getListData();
    }

    private onFilterChanged(data: any) {
        this.selectedStatus = data.status;
        this.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.getListData();        
    }

    private onReloadOrder() {
        this.getListData();
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listOrder = this.listOrder.map(x => {
            return {
                ...x,
                isChecked: x.status === 0 ? isCheckAll : x.isChecked
            }
        });
    }

    private async onActionStatus(action: any) {
        this.actionSelected = action;
        if (this.actionSelected !== this.actions.new && this.totalChoose === 0) {
            Vue.notify({group: 'foo',type: 'warn',title: 'Thông báo!',text: 'Không có đơn hàng nào được chọn!'});
            return false;
        }
        switch(this.actionSelected) {
            case this.actions.cancel: {
                const countNoWaitDeposit = this.listOrder.filter(x => x.status !== 0 && x.status !== 3 && x.isChecked === true).length;
                if (countNoWaitDeposit > 0) {
                    Vue.notify({group: 'foo',type: 'warn',title: 'Thông báo!',text: 'Chức năng này chỉ dành cho những đơn chưa đặt cọc!'});
                    return false;
                }
                const listDeposit = this.listOrder.filter(x => (x.status === 0 || x.status === 3) && x.isChecked === true);
                this.modalContent = this.onModalContentCancel(listDeposit);
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.deposit: {
                const countNoWaitDeposit = this.listOrder.filter(x => x.status !== 0 && x.isChecked === true).length;
                if (countNoWaitDeposit > 0) {
                    Vue.notify({group: 'foo',type: 'warn',title: 'Thông báo!',text: 'Chức năng này chỉ dành cho những đơn CHỜ ĐẶT CỌC!'});
                    return false;
                }
                if (this.customerInfo.Wallet >= this.amountNeedDeposit) {
                    const listDeposit = this.listOrder.filter(x => x.status === 0 && x.isChecked === true);
                    this.modalContent = this.onModalContentDeposit(listDeposit, this.amountNeedDeposit);
                    this.isConfirm = true;
                    this.showNextConfirm = true;
                } else {
                    this.modalContent = `<div style="color: #111;">Số tiền trong ví của bạn không đủ để đặt cọc.</div>
                                        <div>Tiền cần cọc: <span class="fb">${formatNumber(this.amountNeedDeposit, '0,0')} VND</span></div>
                                        <div>Ví: <span class="fb">${formatNumber(this.customerInfo.Wallet, '0,0')} VND</span></div>
                                        <div class="text-danger">Hãy nạp tiền để tiếp tục đặt cọc!</div>`;
                    this.isConfirm = true;
                    this.showNextConfirm = false;
                }
                break;
            }
            case this.actions.new: {
                const routeData = this.$router.resolve({ name: 'order-new' });
                window.open(routeData.href, '_blank');
            }  
        }
    }

    private async submitDepositOrder() {
        this.isLoading = true;
        const dataRequest = {
            type: 2,
            ids: this.listOrder
                    .filter(x => x.status === 0 && x.isChecked === true)
                    .map(x => x.id)
        }
        const result = await orderService.updateMultiOrder(dataRequest);

        if (result && result.status === 200 && result.data.data.status === true) {
            Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Đặt cọc đơn hàng thành công!'});
            this.getCustomersInfo();
            this.getListData();
        } else {
            this.isLoading = false;
        }
    }

    private async submitCancelOrder() {
        this.isLoading = true;
        const dataRequest = {
            type: 1,
            ids: this.listOrder
                    .filter(x => (x.status === 0 || x.status === 3) && x.isChecked === true)
                    .map(x => x.id)
        }
        const result = await orderService.updateMultiOrder(dataRequest);

        if (result && result.status === 200 && result.data.data.status === true) {
            Vue.notify({group: 'foo',type: 'success',title: 'Thông báo!',text: 'Hủy đơn hàng thành công!'});
            this.getListData();
        } else {
            this.isLoading = false;
        }
    }

    private onModalContentDeposit(listDeposit: Order[], amountNeedDeposit) {
        let modalContent = `<div class="modal-happy">Bạn có muốn đặt cọc cho <span class="fb text-danger">${listDeposit.length}</span> đơn dưới đây không?
                            <div>
                                <ul>`
        for(const order of listDeposit) {
            modalContent += `<li>`;
            modalContent += `<div>[Mã đơn: <span class="fb">${order.id}</span>]<span class="text-danger ml10 fr">${ formatNumber(order.minDeposit, '0,0') } <i>VND</i></span></div>`
            modalContent += `</li>`;
        }

        modalContent += `<li><div class="text-danger fb">TỔNG TIỀN CỌC<span class="fb ml10 fr">${ formatNumber(amountNeedDeposit, '0,0') } <i>VND</i></span></div></li>`;

        modalContent += `</ul></div>`;
        

        return modalContent;
    }

    private onModalContentCancel(listCancel: Order[]) {
        let modalContent = `<div class="modal-happy">Bạn có muốn hủy <span class="fb text-danger">${listCancel.length}</span> đơn dưới đây không?
                            <div><ul>`
        for(const order of listCancel) {
            modalContent += `<li class="item">`;
            modalContent += `<div>[Mã đơn: <span class="fb">${order.id}</span>]</div>`
            modalContent += `</li>`;
        }

        modalContent += `</ul></div>`;
        

        return modalContent;
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.searchText !== null &&
            this.searchText !== undefined &&
            this.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'ShopName',
                    value: this.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'Site',
                    value: this.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'comments',
                    value: this.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.cancel) {
            this.submitCancelOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.deposit) {
            this.submitDepositOrder();
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }
}
